import React from 'react'
import AppLayout from '@/Layouts/AppLayout'
import { Container } from '@/Components'

import { usePage } from '@inertiajs/inertia-react'
import {Inertia} from "@inertiajs/inertia";
import { ROLE_ID } from "@/Enums/roles"

import EmissionsOwner from "@/Pages/Emissions/Index/EmissionsOwner"
import {PlanUpgradeNotice} from "@/Components/PlanUpgradeNotice";
import {PlanPermissionContainer} from "@/Components/PlanPermissionContainer";

export default function EmissionsIndex({ teams }) {

  const user = usePage().props?.auth?.user?.data || {}

  if(user?.organization_role_id === ROLE_ID.REPORTER) {
    Inertia.visit('/emission-accounting/report');
  }

  return (
    <>
      <Container size={"4xl:max-w-screen-3xl"} padding={"px-4 lg:px-16 4xl:pl-32"} className="4xl:mx-0 mt-4">
        {user?.organization_role_id === ROLE_ID.OWNER &&
          <EmissionsOwner teams={teams.data} />
        }

        <PlanPermissionContainer>
          <PlanUpgradeNotice title="Is one team not enough?" subtitle="Level up to Emma Custom to get unlimited teams"/>
        </PlanPermissionContainer>

      </Container>
    </>
  )
}

EmissionsIndex.layout = page => (
  <AppLayout title="Emission Accounting">{page}</AppLayout>
)
